<template lang="pug">
  div.info-msg
    div.info-msg__circle(:class="{'info-msg__circle--alert': alert}")
      span.info-msg__circle__content {{ alerts }}
    div.info-msg__label
      span.info-msg__label__text {{ $t(labelText) }}
</template>

<script>
export default {
  name: 'InfoMsg',
  data () {
    return {
      labelText: '',
      countAlert: ''
    }
  },
  props: {
    alerts: {
      type: Number,
      default: 0
    },
    alert: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Selected Element'
    }
  },
  methods: {
    init () {
      const component = this
      if (component.alert) {
        component.labelText = 'Alertas'
        !component.alerts ? component.countAlert = 0 : component.countAlert = component.alerts
      } else {
        component.labelText = component.label
        component.countAlert = '0'
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>

  .info-msg {
    display: flex;
    &__circle {
      align-items: center;
      background-color: $--color-white;
      border-radius: 50%;
      border: 1px solid $--color-grey-low;
      // color: $--color-primary;
      height: rem(32);
      justify-content: center;
      margin-right: rem(8);
      min-width: rem(32);
      position: relative;
      text-align: center;
      &--alert {
        background-color: $--color-red-dark;
        color: $--color-white;
        margin-left: rem(12);
      }
      &__content {
        @extend %font-info-number;
        display: flex;
        font-size: rem(12);
        justify-content: center;
        align-items: center;
        height: 100%;
      }
    }
    &__label {
      max-width: rem(112);
      height: rem(32);
      align-items: center;
      &__text {
        @extend %font-info-label;
        color: $--color--grey-medium;
        text-transform: uppercase;
        justify-content: center;
        align-items: center;
        height: 100%;
        display: flex;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/InfoMsg.vue